import React, { useEffect, useRef, useState } from "react";
import "react-responsive-modal/styles.css";
import leftArrow from "../../assets/Images/left-arrow.png";
import rightArrow from "../../assets/Images/right-arrow.png";
import "./risk.css";
import { DPR_API } from "../../services/apiCalls/dprApiCalls";

export default function RiskResgisterList({ subId }) {
  const [riskList, setRiskList] = useState([]);

  const getRiskData = async () => {
    const state = JSON.parse(localStorage.getItem("state"));
    setCurrentPage(1);
    let obj = {
      UserID: state.user.user_id,
      TaskID: subId,
    };
    const risk = await DPR_API.GetRiskAllocationDetails(obj);
    // debugger;
    if (risk.status === 200) {
      setRiskList(risk.RiskList);
    } else {
      setRiskList([]);
    }
  };

  useEffect(() => {
    getRiskData();
  }, []);

  const handleRowSelect = (id) => {
    // let newSelectedRows = [...selectedRows];
    // if (newSelectedRows.includes(id)) {
    //     newSelectedRows = newSelectedRows.filter((rowId) => rowId !== id);
    // } else {
    //     newSelectedRows.push(id);
    // }
    // setSelectedRows(newSelectedRows);
    // setSelectAll(newSelectedRows.length === data.length);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(riskList.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = riskList.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <React.Fragment>
      <div className="table-container" style={{width:'100%'}}>
        <table className="custom-table">
          <thead className="table-header">
            <tr>
              <th>Sr No</th>
              <th>Project Name</th>
              <th>Product Category</th>
              <th>Project Location</th>
              <th>Impact Level</th>
              <th>Risk Due Date</th>
              <th>Risk Status</th>
              <th>Created Date</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, index) => (
              <tr key={index}>
                <td>{index + 1 + (currentPage - 1) * 10}</td>
                <td id="elps" title={row.ProjectName}>
                  {row.ProjectName}
                </td>
                <td id="elps" title={row.ProductCategory}>
                  {row.ProductCategory ? row.ProductCategory : "-"}
                </td>
                <td id="elps" title={row.ProjectLocation}>
                  {row.Location ? row.Location : "-"}
                </td>
                <td id="elps" title={row.ImpactLevel}>
                  {row.ImpactLevel ? row.ImpactLevel : "-"}
                </td>
                <td id="elps" title={row.RiskDueDate}>
                  {row.RiskDueDate ? row.RiskDueDate : "-"}
                </td>
                <td id="elps" title={row.RiskStatus}>
                  {row.RiskStatus ? row.RiskStatus : "-"}
                </td>
                <td>{new Date(row?.CreatedOn).toLocaleDateString('en-GB')}</td>
                {/* <td style={{ cursor: 'pointer' }}>
                                <img src={Add} width={20} onClick={onOpenModal} />
                            </td> */}
              </tr>
            ))}
          </tbody>
        </table>
        <div
          className="pagination"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 15px",
          }}
        >
          <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
            Showing{" "}
            {Math.min((currentPage - 1) * rowsPerPage + 1, riskList.length)} to{" "}
            {Math.min(currentPage * rowsPerPage, riskList.length)} of{" "}
            {riskList.length} entries
          </div>

          <div
            className="pagination-buttons"
            style={{
              fontSize: "14px",
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              gap: "5px",
            }}
          >
            <button
              onClick={() => handleClick(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={leftArrow}
                alt="Previous"
                height="11px"
                width="7px"
                style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
              />
            </button>

            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                onClick={() => handleClick(i + 1)}
                style={{
                  background: currentPage === i + 1 ? "#00B69B" : "transparent",
                  color: currentPage === i + 1 ? "#fff" : "#000",
                  border: "none",
                  borderRadius: "50%",
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                {i + 1}
              </button>
            ))}

            <button
              onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
              disabled={currentPage === totalPages}
              style={{
                background: "none",
                border: "none",
                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              }}
            >
              <img
                src={rightArrow}
                alt="Next"
                height="11px"
                width="7px"
                style={{
                  opacity: currentPage === totalPages ? 0.5 : 1,
                }}
              />
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
